export default __webpack_public_path__ + "static/media/hht1_ep04_timeline_q02_b.f04d0d59.png";